export default __webpack_public_path__ + "static/media/add-icon.cf574620.svg";